var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcInviteRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1450_5564)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2576 26.7623C25.2576 27.2189 24.8874 27.5891 24.4308 27.5891L16.163 27.5891C15.7064 27.5891 15.3362 27.2189 15.3362 26.7623C15.3362 26.3057 15.7064 25.9355 16.163 25.9355L24.4308 25.9355C24.8874 25.9355 25.2576 26.3057 25.2576 26.7623Z",
    fill: "#F8693E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0842 30.069C26.0842 30.5256 25.7141 30.8957 25.2574 30.8957H18.6432C18.1866 30.8957 17.8164 30.5256 17.8164 30.069C17.8164 29.6123 18.1866 29.2422 18.6432 29.2422H25.2574C25.7141 29.2422 26.0842 29.6123 26.0842 30.069Z",
    fill: "#F8693E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1509 33.3756C28.1509 33.8322 27.7807 34.2024 27.3241 34.2024H21.95C21.4934 34.2024 21.1233 33.8322 21.1233 33.3756C21.1233 32.919 21.4934 32.5488 21.95 32.5488H27.3241C27.7807 32.5488 28.1509 32.919 28.1509 33.3756Z",
    fill: "#F8693E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2048 31.666C34.5379 31.8998 34.808 32.0822 35.0154 32.2129C35.2225 32.3438 35.498 32.478 35.8425 32.6143C36.1871 32.7507 36.5086 32.8183 36.8064 32.8184H36.824C37.1218 32.8184 37.4432 32.7507 37.7878 32.6143C38.1323 32.4779 38.4086 32.3439 38.616 32.2129C38.8234 32.0822 39.0938 31.8997 39.4265 31.666C39.5241 31.5987 39.6275 31.5278 39.7341 31.4551L44.1814 35.6943C43.9215 35.9134 43.6161 36.0244 43.2634 36.0244H30.3679C30.0151 36.0244 29.7089 35.9136 29.449 35.6943L33.8972 31.4541C34.0085 31.5302 34.112 31.6012 34.2048 31.666ZM29.0281 27.7148C29.2764 27.996 29.562 28.2459 29.8835 28.4639C31.0822 29.2919 32.0584 29.9739 32.8162 30.5117L29.0281 34.3623V27.7148ZM44.6033 34.3623L40.8142 30.5127C41.6216 29.9397 42.6022 29.2572 43.7556 28.4639C44.0774 28.2401 44.3604 27.9904 44.6033 27.7148V34.3623ZM43.2117 23.9746C43.5882 23.9746 43.9149 24.1128 44.1902 24.3887C44.4652 24.665 44.6023 24.9971 44.6023 25.3848C44.6023 25.8487 44.4608 26.2922 44.1775 26.7148C43.8935 27.1376 43.5399 27.4994 43.1169 27.7988C41.7107 28.7883 40.649 29.5354 39.9285 30.043C39.5329 30.3214 39.2385 30.5288 39.0496 30.6621C39.0215 30.6821 38.9778 30.7145 38.9197 30.7568C38.857 30.8023 38.777 30.8601 38.6794 30.9316C38.4913 31.0696 38.3352 31.1814 38.2107 31.2666C38.0859 31.3517 37.9352 31.447 37.7585 31.5527C37.5817 31.6585 37.4149 31.7372 37.2585 31.79C37.1021 31.8428 36.9572 31.8701 36.824 31.8701H36.8074C36.6742 31.8701 36.5292 31.8428 36.3728 31.79C36.2165 31.7372 36.0494 31.6583 35.8728 31.5527C35.6961 31.447 35.545 31.3518 35.4207 31.2666C35.2961 31.1813 35.1392 31.0697 34.9509 30.9316C34.8532 30.8601 34.7743 30.8015 34.7117 30.7559C34.6536 30.7138 34.6096 30.6819 34.5818 30.6621C34.3392 30.4892 34.0455 30.2807 33.7048 30.04C33.3051 29.7574 32.8394 29.4305 32.3044 29.0547C31.3139 28.359 30.7203 27.94 30.5232 27.7988C30.1639 27.5522 29.8242 27.213 29.5056 26.7812C29.1871 26.3494 29.0281 25.948 29.0281 25.5781C29.0281 25.1205 29.1482 24.7388 29.3884 24.4336C29.6288 24.1283 29.9724 23.9746 30.4187 23.9746H43.2117Z",
    fill: "#F8693E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1450_5564",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.419608 0 0 0 0 0.27451 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1450_5564"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1450_5564",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInviteRed);
export default __webpack_public_path__ + "static/media/icInviteRed.a6987e1ad197453d132cff010e7565bd.svg";
export { ForwardRef as ReactComponent };